import { Component, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from '../../services/clipboard.service'
import { Router } from '@angular/router';
import {
  MatDialog,
  MatDialogRef,
  MatSnackBar,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatPaginator,
} from "@angular/material";
import { CreativeMasterCommentModalComponent } from '../creative-master/creative-master-comment-modal/creative-master-comment-modal.component';
@Component({
  selector: 'app-comment-master',
  templateUrl: './comment-master.component.html',
  styleUrls: ['./comment-master.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class CommentMasterComponent implements OnInit {
  createdAt:any;
  showComponentLoader = false;
  authToken = localStorage.getItem('token')
  createdByList:any;
  selectedCreatedBy:any;
  campaignList:any;
  selectedCampaign:any;
  accountManagerList:any = []
  selectedAccountManager:any = [];
  salePersonList:any;
  selectedSalePerson:any;
  allIsActive:boolean=true;
  selectedForMe:any;
  url:any = "";
  pageIndex: number = 0;
  pageSize: number = 100;
  commentedBy:any
  lenCount: any = 0;
  comments:any;
  commentedByAllUser:any = null
  selectedCommentedByUser:any = [];
  temp = localStorage.removeItem('masterComment')
  // selectedModule:any = [];
  // prop:any;
  // selectedModule =  ["CreativeJob", "Campaign", "MarketingJob", "Escalation", "PreSalesJob", "CampaignTask"];
  selectedModule: string[] = ["CreativeJob", "Campaign", "MarketingJob", "Escalation", "PreSalesJob", "CampaignTask"];
  prop = { 'border': '1px solid #C5F2E6', 'background-color': '#FCFCFC','font-weight':400,'color':'#1F1F1F' };
  selectedCommentedBy:any;
  userInfo = JSON.parse(localStorage.getItem('userInfo'))
  searchItem = '';
  filteredAccountManagerList = []
   creativeMasterCommentModalComponent: MatDialogRef<CreativeMasterCommentModalComponent>;
  constructor(
    private serverService:ServerService,
    private clipBoardService:ClipBoardService,
    private router:Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    // this.getCreatedBy()
    this.getCampaignForFilter();
    this.getAccountManager();
    this.getSP();
    this.getAllComment();
    this.getAllUser()
    this.getAllUserComment();
    // this.getModule('All');
  }
  
  // isAllSelected(): any {
  //   return (
  //     this.filteredAccountManagerList.length > 0 &&
  //     this.selectedCommentedByUser.length === this.filteredAccountManagerList.length
  //   );
  // }

  // toggleSelectAll(event: any): void {
  //   if (this.isAllSelected()) {
  //     this.selectedCommentedByUser = []; 
  //   } else {
  //     this.selectedCommentedByUser = this.filteredAccountManagerList.map(item => item.id); 
     
  //   }
  //   this.getAllComment('filter'); 
  // }
 
  isItemSelected(item: any): boolean {
    if(this.selectedCommentedByUser.length > 0){
    return this.selectedCommentedByUser.includes(item.id)
    }
  }

  filteronSearch(event:any){
    const term = this.searchItem.toLowerCase();
    this.filteredAccountManagerList = this.commentedByAllUser.filter(user =>
      user.name.toLowerCase().includes(term) ||
      user.email.toLowerCase().includes(term) ||
      (user.role && user.role.toLowerCase().includes(term))
    );

    
  }

  getCampaignForFilter() {

    this.showComponentLoader = true;

    this.serverService.getCampaignForFilter("campaign_module/campaign/list", this.authToken).subscribe(
      data => {
        this.campaignList = data;
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  getAccountManager(){
    this.showComponentLoader = true

    let url = "campaign_module/get_marketing_user";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.accountManagerList = data.data
      // this.filteredAccountManagerList = [...this.accountManagerList];
      // this.accountManagerList.unshift({id:null, name:'Account Manager'})
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  getAllUser(){
    this.showComponentLoader = true

    let url = "campaign_module/user_list";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.commentedBy = data.data
      // this.commentedBy.unshift({id:null, name:'Select User'})
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getAllUserComment(){
    this.showComponentLoader = true

    let url = "campaign_module/user_list";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.commentedByAllUser = data.data
      // console.log(this.commentedByAllUser)
       this.filteredAccountManagerList = [...this.commentedByAllUser];
      // this.commentedBy.unshift({id:null, name:'Select User'})
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  getSP() {
    this.showComponentLoader = true;

    let url = "/campaign_module/user_list?user_type=SalesAdmin";
    this.serverService.getSalePerson(url, this.authToken).subscribe(
      (data) => {
        this.salePersonList = data.data;
        // this.salePersonList.unshift({ id: null, name: "Sales Person" });
        //console.log(this.salePersonList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }
  // allCommentMaster(isFilter?:any) {

  //   if(isFilter=='filter'){
  //     this.allIsActive = false
  //   }
  // }
  resetFilter(){
    this.allIsActive = true;
 
    this.selectedCreatedBy = null
   
    this.selectedCampaign = null

    this.selectedAccountManager = null
  
    this.selectedSalePerson = null

    this.selectedForMe = false;

    this.selectedCommentedBy = null;

    this.selectedCommentedByUser = [];

    this.searchItem = ''
    this.filteredAccountManagerList = [...this.commentedByAllUser];
    // console.log(this.filteredAccountManagerList)

    this.getAllComment();
    
  }
  selectItem(item: any, event: Event): void {
    event.stopPropagation(); 
  
    const index = this.selectedCommentedByUser.indexOf(item.id);
  
    if (index > -1) {
      this.selectedCommentedByUser = this.selectedCommentedByUser.filter(id => id !== item.id);
    } else {
      this.selectedCommentedByUser = [...this.selectedCommentedByUser, item.id];
    }
  
    this.getAllComment('filter');
  }
  
  getAllComment(isFilter?:any,for_me?:any){
    // this.prop = {}
    // debugger;
    localStorage.removeItem('masterComment')
    this.showComponentLoader = true
  let body = {
    // "campaign_id": this.selectedCampaign,
    "comment_filters":{
      "module_type":this.selectedModule
      // "module_type": ["Campaign"]
    }
  }
  if(isFilter){
    this.allIsActive = false;
    // this.selectedCommentedByUser = []
  }
  // this.searchItem = '';
  if(for_me == 'for_me'){
    this.selectedForMe = true;
      body["comment_filters"]["assigned_to_me"] = this.userInfo.id
    
  }
 if(this.selectedForMe){
  body["comment_filters"]["assigned_to_me"] = this.userInfo.id
 }

  if (this.createdAt != undefined && this.createdAt != "") {
    body["comment_filters"]["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
  }


  if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
    body["campaign_id"] = this.selectedCampaign;
  }

 

  
  if (this.selectedAccountManager != undefined && this.selectedAccountManager != "") {
    body["account_manager_id"] = this.selectedAccountManager;
  }
  
  if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
    body["sales_manager_id"] = this.selectedSalePerson;
  }
  
 

  if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
    body["comment_filters"]["created_by"] = this.selectedCreatedBy
  }

  if (this.selectedCommentedBy != undefined && this.selectedCommentedBy != "") {
    body["comment_filters"]["created_by"] = this.selectedCommentedBy
  }
  if (this.selectedCommentedByUser != undefined && this.selectedCommentedByUser != "") {
    body["comment_filters"]["tagged_user_id"] = this.selectedCommentedByUser
  }
  // console.log(this.searchItem)
  // if(this.searchItem != ''){
  //   // console.log(this.searchItem)
  // this.filteredAccountManagerList = [...this.commentedByAllUser];
  // // this.searchItem = ''
  // }


  this.pageIndex = 0;
  this.pageSize = 50;

  this.showComponentLoader = true;

  this.url = "campaign_module/comments/master_list?per_page=" + this.pageSize + "&page=" + this.pageIndex;

  this.serverService.campaignListByFilter(this.url, body, this.authToken).subscribe(
    data => {
      this.comments = data;
      this.lenCount = data.comments.length
      //console.log(this.lenCount)
      this.showComponentLoader = false
    },
    err => {
      this.showComponentLoader = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
  )
}
clearAll(){
  // console.log("hi")
  this.selectedCommentedByUser = []
  this.getAllComment('filter')

}
getNext(event) {
  // this.prop = {}
  this.showComponentLoader = true

  let body1 = {
    "per_page": event.pageSize,
    "page": event.pageIndex
  };

  this.pageSize = body1.per_page;
  this.pageIndex = body1.page
  let indexPage = this.pageIndex + 1

  let body = {
    // "campaign_id": this.selectedCampaign,
    "comment_filters":{
      "module_type":this.selectedModule
    }
  }

 

  if (this.createdAt != undefined && this.createdAt != "") {
    body["comment_filters"]["created_at"] = [this.createdAt.formatted.split(" - ")[0], this.createdAt.formatted.split(" - ")[1]];
  }


  if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
    body["campaign_id"] = this.selectedCampaign;
  }

 

  
  if (this.selectedAccountManager != undefined && this.selectedAccountManager != "") {
    body["account_manager_id"] = this.selectedAccountManager;
  }
  
  
  if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
    body["sales_manager_id"] = this.selectedSalePerson;
  }
  
 

  if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
    body["comment_filters"]["created_by"] = this.selectedCreatedBy
  }

  if (this.selectedCommentedBy != undefined && this.selectedCommentedBy != "") {
    body["comment_filters"]["created_by"] = this.selectedCommentedBy
  }

  if (this.selectedForMe != undefined && this.selectedForMe != "") {
    body["comment_filters"]["assigned_to_me"] = this.userInfo.id
  }
  //console.log(body)
  if(this.selectedForMe){
    body["comment_filters"]["assigned_to_me"] = this.userInfo.id
   }

   if (this.selectedCommentedByUser != undefined && this.selectedCommentedByUser != "") {
    body["comment_filters"]["tagged_user_id"] = this.selectedCommentedByUser
  }
  
  this.showComponentLoader = true;

  this.url = "campaign_module/comments/master_list?per_page=" + this.pageSize + "&page=" + indexPage;

  this.serverService.campaignListByFilter(this.url, body, this.authToken).subscribe(
    data => {
      this.comments = data;
      // this.lenCount = data.comments.length
      //console.log(this.lenCount)
      this.showComponentLoader = false
    },
    err => {
      this.showComponentLoader = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
  )
}

selectCreatedDate(event:any){ 
  if (event.formatted != undefined && event.formatted != "" && event.formatted != null) {
    this.createdAt = event
    this.getAllComment('filter')
  } else {
    this.createdAt = undefined;
    this.getAllComment('filter')
  }
}
getModule(module: any) {
  switch (module.toLowerCase()) {
    case 'all':
      this.selectedModule = ["CreativeJob", "Campaign", "MarketingJob", "Escalation", "PreSalesJob", "CampaignTask"];
      break;
    case 'creativejob':
      this.selectedModule = ["CreativeJob"];
      break;
    case 'campaigns':
      this.selectedModule = ["Campaign"];
      break;
    case 'marketingjob':
      this.selectedModule = ["MarketingJob"];
      break;
    case 'escalation':
      this.selectedModule = ["Escalation"];
      break;
    case 'presalesjob':
      this.selectedModule = ["PreSalesJob"];
      break;
    case 'campaigntask':
      this.selectedModule = ["CampaignTask"];
      break;
    default:
      this.selectedModule = [];
  }
  this.getAllComment();
}
getBgColor(item:any){
  // debugger;
 item = item.commentable.module_name;
  item = item.toLowerCase()
  switch(item){
    case 'escalation':return {'background-color':'#FCD2CD','border': '0.5px solid rgba(220, 185, 181, 1)'};
  
    case 'marketingjob':return {'background-color':'#FDE2C9','border': '0.5px solid rgba(228, 203, 182, 1)'}
  
    case 'presalesjob':return {'background-color':'rgba(217, 255, 233, 0.7)','border':'0.5px solid rgba(206, 238, 220, 1)'}
  
    case 'creativejob':return {'background-color':'#F8E6FF','border': '0.5px solid rgba(233, 216, 240, 1)'}
  
    case 'campaigntask':return {'background-color':'#FFF9E0','border': '0.5px solid #F0E9CF'}
  
    case 'campaign':return {'background-color':'#EAF4FF','border': '0.5px solid #DEE9F4'}
    default:return {'background-color':'#FFF9E0'}
    // CampaignTask
  }
}
navToCampaign(item:any){

  let id;
  if(item.commentable.module_name.toLowerCase() == 'campaign'){
     id = item.commentable.id
  }
  else{
     id = item.commentable.campaign.id
  }
  // return;
  this.router.navigate([]).then(result => { window.open('page/campaign-details/' + id, '_blank'); });
}
formatMentions(comment: string): string {
  if (!comment) return '';

  return comment.replace(
    /<span class="mention"[^>]*>(.*?)<\/span>/g,
    `<span class="mention-highlight">$1</span>`
  );
}
commentMasterCommentModal(project) {
    project["commentType"] = "commentmaster";
    this.creativeMasterCommentModalComponent = this.dialog.open(
      CreativeMasterCommentModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1020px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.creativeMasterCommentModalComponent
      .afterClosed()
      .subscribe((result) => {
        // console.log(result)
        if (result != undefined) {
          this.showComponentLoader = true;
          this.getAllComment();
        }
        if(localStorage.getItem('masterComment') == "true"){
          this.getAllComment();

        }
      });
  }

}
